import { Bus, BusStop, Class } from '@/plugins/api'
import alert from '@/plugins/alert'
import { textHelpers } from '../../helpers/TextHelper'
export default {
  namespaced: true,
  state: {
    busData: {},
    weekdays: {},
    classes: [],
  },
  actions: {
    async initBus({ commit }, id) {
      let busData = await Bus.fetchOne(id)
      let busSchedules = busData.bus_schedules
      const listBusStop = await BusStop.fetch({
        bus: busData.id,
        _limit: -1,
      })
      const classes = await Class.getClassWithGrade({})
      busSchedules = busSchedules.map(item => {
        let busStops = listBusStop.filter(busStop => busStop.busSchedule.id === item.id)
        return { ...item, busStops }
      })
      let valueStart = null
      let weekdays = {
        monday: valueStart,
        tuesday: valueStart,
        wednesday: valueStart,
        thursday: valueStart,
        friday: valueStart,
        saturday: valueStart,
      }
      busSchedules.map(item => {
        let key = textHelpers.getKeyBusSchedule(item.periodTime, item.direction)
        if (weekdays[item.dayOfWeek]) {
          let arr = weekdays[item.dayOfWeek]
          arr[key] = { ...item, key }
          weekdays[item.dayOfWeek] = arr
        } else {
          let arr = [0, 1, 2, 3]
          arr[key] = { ...item, key }
          weekdays[item.dayOfWeek] = arr
        }
      })
      commit('changeState', { busData, weekdays, classes })
    },
    async fetchBus({ commit }, id) {
      commit('setBus', null)
      commit('setBus', await Bus.fetchOne(id))
    },
    async updateBus({ commit }, busData) {
      try {
        const bus = await Bus.update(busData.id, busData)
        alert.success('Chỉnh sửa thành công!')
        commit('setBus', bus)
      } catch (e) {
        alert.error(e)
      }
    },
    async createBusStop({ state, dispatch }, { data, week }) {
      try {
        if (!week) await BusStop.create({ ...data })
        else await BusStop.addBusStopInAllDay({ ...data })
        dispatch('initBus', state.busData.id)
        alert.success('Thêm mới điểm dừng thành công!')
      } catch (e) {
        alert.error(e)
      }
    },
    async updateStudentBusStop(
      { state, dispatch },
      { id, student, selectDaysOfTheWeek, address, direction, periodTime },
    ) {
      if (!selectDaysOfTheWeek) {
        await BusStop.addStudentInBusStop(id, { students: [student] })
      } else {
        await BusStop.addStudentInBusStopInAllDay(id, {
          student,
          address,
          direction,
          periodTime,
        })
      }
      dispatch('initBus', state.busData.id)
    },
    async deleteStudentBusStop({ state, dispatch }, { id, students }) {
      await BusStop.deleteStudentInBusStop(id, { students: students })
      dispatch('initBus', state.busData.id)
    },
    async updateBusStop({ state, dispatch }, { id, ...data }) {
      try {
        await BusStop.update(id, data)
        dispatch('initBus', state.busData.id)
        alert.success('Chỉnh sửa điểm dừng thành công!')
      } catch (e) {
        alert.error(e)
      }
    },
    async removeBusStop({ state, dispatch }, data) {
      try {
        await BusStop.remove(data.id)
        dispatch('initBus', state.busData.id)
        alert.success('Xóa điểm dừng thành công!')
      } catch (e) {
        alert.error(e)
      }
    },
    async updateBusStopOrder(_, params) {
      await BusStop.updateBusStopOrder(params)
    },
  },
  mutations: {
    setBus(state, busData) {
      state.busData = busData
    },
  },
  getters: {
    busData: state => state.busData,
    weekdays: state => state.weekdays,
    classes: state => state.classes,
  },
}
